<template>
  <div class="panel">
    <div class="panel-heading">
      Registrar productos <br />
    </div>
    <div class="section">
      <div class="panel-block">
        <div class="columns">
          <div class="colum">
            <form>
              <div class="field">
                <label class="label">Nombre</label>
                <div class="control">
                  <input
                    class="input is-success"
                    type="text"
                    v-model="nombreproducto"
                    placeholder="Nombre del producto químico"
                  />
                </div>
              </div>
              <div class="field">
                <label class="label"
                  >Tipo de producto químico según
                  <a href="https://unece.org/rev-21-2019" target="_"> ONU</a>
                  {{ selected }}</label
                >
                <div class="control">
                  <div class="select">
                    <select v-model="selected">
                      <option v-for="option in options" :key="option.id">{{
                        option.text
                      }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <button
                class="button is-warning"
                v-if="showregister"
                v-on:click.prevent="register"
              >
                Registrar
              </button>
            </form>
          </div>
          <div class="column">
            <img :src="imgsrc2" v-if="imgsrc2 !== null" />
            <img :src="imgsrc3" v-if="imgsrc3 !== null" />
            <img :src="imgsrc" v-if="imgsrc !== null" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const products = require('../js/products')
function get(imgname) {
  return require('../matrizimg/' + imgname)
}
export default {
  data: () => ({
    selected: '',
    nombreproducto: '',
    imgsrc: null,
    imgsrc2: null,
    imgsrc3: null,
    options: [
      {
        id: '1.1',
        text: '1.1 Explosivo',
        img: get('GHS-pictogram-explos.png'),
        img2: get('1-1.webp')
      },
      {
        id: '1.2',
        text: '1.2 Explosivo',
        img: get('GHS-pictogram-explos.png'),
        img2: get('1-2.webp')
      },
      {
        id: '1.3',
        text: '1.3 Explosivo',
        img: get('GHS-pictogram-explos.png'),
        img2: get('1-3.webp')
      },
      {
        id: '1.4',
        text: '1.4 Explosivo',
        img: get('GHS-pictogram-explos.png'),
        img2: get('1-4.webp')
      },
      { id: '1.5', text: '1.5 Explosivo', img: null, img2: get('1-5.webp') },
      { id: '1.6', text: '1.6 Explosivo', img: null, img2: get('1-6.webp') },
      {
        id: '2.1',
        text: '2.1 Gases inflamables',
        img: get('GHS-pictogram-flamme.png'),
        img2: get('rouge2.webp'),
        img3: get('rouge2_noir.webp')
      },
      {
        id: '2.2',
        text: '2.2 Gases no inflamables',
        img: get('GHS-pictogram-bottle.png'),
        img2: get('vert.webp'),
        img3: get('vert_blanc.webp')
      },
      {
        id: '2.3',
        text: '2.3 Gases tóxicos',
        img: get('GHS-pictogram-skull.png'),
        img2: get('skull_2.webp')
      },
      {
        id: '3',
        text: '3 Líquido inflamable',
        img: get('GHS-pictogram-flamme.png'),
        img2: get('rouge3.webp'),
        img3: get('rouge3_noir.webp')
      },
      {
        id: '4.1',
        text: '4.1 Sólidos inflamables',
        img: get('GHS-pictogram-flamme.png'),
        img2: get('stripes.webp')
      },
      {
        id: '4.2',
        text: '4.2 Sólido inflamable',
        img: get('GHS-pictogram-flamme.png'),
        img2: get('blan-red.webp')
      },
      {
        id: '4.3',
        text: '4.3 Sólido inflamable',
        img: null,
        img2: get('bleu4.webp'),
        img3: get('bleu4_noir.webp')
      }, // sin pictograma SGA
      {
        id: '5.1',
        text: '5.1 Sustancia comburente',
        img: get('GHS-pictogram-rondflam.png'),
        img2: get('jaune5-1.webp')
      },
      {
        id: '5.2',
        text: '5.2 Peróxidos orgánicos',
        img: get('GHS-pictogram-rondflam.png'),
        img2: get('5-2red.webp'),
        img3: get('5-2red_noir.webp')
      },
      {
        id: '6.1',
        text: '6.1 Sustancias tóxicas',
        img: get('GHS-pictogram-skull.png'),
        img2: get('skull6.webp')
      },
      {
        id: '6.2',
        text: '6.2 Sustancias infecciosas',
        img: get('GHS-pictogram-skull.png'),
        img2: get('6.2.webp')
      },
      {
        id: '7A',
        text: '7A Material radioactivo Categoría I',
        img: null,
        img2: get('7A.webp')
      }, // sin pictograma SGA
      {
        id: '7B',
        text: '7B Material radioactivo Categoría II',
        img: null,
        img2: get('7B.webp')
      }, // sin pictograma SGA
      {
        id: '7C',
        text: '7C Material radioactivo Categoría II',
        img: null,
        img2: get('7C.webp')
      }, // sin pictograma SGA
      {
        id: '7E',
        text: '7E Material radioactivo sustancias fisionables',
        img: null,
        img2: get('7E.webp')
      }, // sin pictograma SGA
      {
        id: '8',
        text: '8 Sustancia corrosiva',
        img: get('GHS-pictogram-acid.png'),
        img2: get('acide.webp')
      },
      {
        id: '9',
        text:
          '9 sustancias y objetos peligrosos varios, sustacias peligrosas para el medio ambiente',
        img: null,
        img2: get('9.webp')
      },
      {
        id: '9A',
        text:
          '9A sustancias y objetos peligrosos varios, sustacias peligrosas para el medio ambiente',
        img: null,
        img2: get('9A.webp')
      }
    ]
  }),
  watch: {
    selected(value) {
      this.imgsrc = null
      this.imgsrc2 = null
      this.imgsrc3 = null
      for (let k of Object.keys(this.options)) {
        if (this.options[k].text === value) {
          this.imgsrc = this.options[k].img
          this.imgsrc2 = this.options[k].img2
          if (Object.keys(this.options[k]).includes('img3')) {
            this.imgsrc3 = this.options[k].img3
          }
          break
        }
      }
    }
  },
  computed: {
    showregister: function() {
      if (this.nombreproducto.length < 4) {
        return false
      }
      if (this.selected !== '') {
        return true
      }
      return false
    }
  },
  methods: {
    register: async function() {
      // se identifica el id para el que se seleccionó el producto
      var id
      for (let k in this.options) {
        if (this.options[k].text === this.selected) {
          id = this.options[k].id
          break
        }
      }
      return await products.post({
        name: this.nombreproducto.toUpperCase(),
        codigo: typeof id === 'string' ? id : id.toString()
      })
    }
  }
}
</script>
<style scoped>
img {
  width: 120px;
  height: 120px;
}
</style>
